import Tr from 'translations/Translations';

const createItem = (label, value,disabled=false) => ({label, value, disabled})

export const VALUES = {
	NEW: 0,
	MY_CRITERIA: 1,
}

export default [
	createItem(Tr('new'), VALUES.NEW),
	createItem(Tr('my_criteria'), VALUES.MY_CRITERIA,true)
]